"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgHeartRounded = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 9.48C1 5.971 3.658 2 7.889 2c1.827 0 3.177.71 4.111 1.51A6.183 6.183 0 0 1 16.111 2C20.342 2 23 5.971 23 9.48c0 1.845-.715 3.55-1.707 5.03-.993 1.48-2.3 2.79-3.582 3.87a30.511 30.511 0 0 1-3.547 2.561c-.49.303-.904.54-1.208.704-.151.081-.28.147-.379.195a3.157 3.157 0 0 1-.24.103A1.098 1.098 0 0 1 12 22c-.124 0-.22-.024-.245-.03a1.158 1.158 0 0 1-.187-.063 3.157 3.157 0 0 1-.145-.067c-.1-.048-.228-.114-.379-.195-.304-.164-.719-.401-1.208-.704A30.516 30.516 0 0 1 6.29 18.38C5.008 17.3 3.7 15.99 2.707 14.51 1.715 13.03 1 11.324 1 9.48Z", fill: "currentColor" }) }))); };
exports.default = SvgHeartRounded;
